
import { Component, Prop, Vue } from "vue-property-decorator";
import ServiceTitle from "@/components/V2/ServiceSection/ServiceTitle.vue";

const ICONS = {
  check: "check",
};

@Component({
  components: {
    ServiceTitle,
  },
})
export default class SectionPreStage extends Vue {
  @Prop({ type: String, default: null }) readonly title: string;
  @Prop({ type: String, default: null }) readonly text: string;
  @Prop({ type: String, default: null }) readonly status: string;
  @Prop({ type: String, default: null }) readonly buttonLabel: string;
  @Prop({ type: Function }) readonly action;
  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;
  @Prop({ type: Object }) readonly list;

  ICONS = ICONS;
}
